// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format5 } from '../../constants';

/** Ethiopia */
const ET: PhoneNumberData = [251, 'ET', 9, format5];

export default ET;
